import SaversTypes from './SaversTypes';

export const setTrailerRequestId = (payload) => ({
  payload,
  type: SaversTypes.SET_SELECTED_TRAILER_REQUEST,
});

export const setLocationRequestId = (payload) => ({
  payload,
  type: SaversTypes.SET_SELECTED_LOCATION_REQUEST,
});

export const setTrailerId = (payload) => ({
  payload,
  type: SaversTypes.SET_SELECTED_TRAILER_ID,
});

export const setRateList = (payload) => ({
  payload,
  type: SaversTypes.SET_RATE_LIST,
});

export const setSelectedRate = (payload) => ({
  payload,
  type: SaversTypes.SET_SELECTED_RATE,
});

export const setSelectedRateResult = (payload) => ({
  payload,
  type: SaversTypes.SET_SELECTED_RATE_RESULT,
});

export const setSelectedRateResultIndex = (payload) => ({
  payload,
  type: SaversTypes.SET_SELECTED_RATE_RESULT_INDEX,
});

export const setLoggedInUserType = (payload) => ({
  payload,
  type: SaversTypes.SET_LOGGEDIN_USER_TYPE,
});

export const setSaversSuppliers = (payload) => ({
  payload,
  type: SaversTypes.SET_SAVERS_SUPPLIER,
});

export const setShipmentList = (payload) => {
  return { payload, type: SaversTypes.SET_SHIPMENT_LIST };
};

export const setShipmentFilters = (payload) => {
  return { payload, type: SaversTypes.SET_SHIPMENT_FILTERS };
};

export const getShipmentListInProgress = (payload) => {
  return { payload, type: SaversTypes.GET_SHIPMENT_LIST_PROGRESS };
};

export const getShipmentListInSuccess = (payload) => {
  return { payload, type: SaversTypes.GET_SHIPMENT_LIST_SUCCESS };
};

export const getShipmentListInError = (payload) => {
  return { payload, type: SaversTypes.GET_SHIPMENT_LIST_ERROR };
};
